import { render, staticRenderFns } from "./ImportAbbreviationDialog.vue?vue&type=template&id=f10ba7e0"
import script from "./ImportAbbreviationDialog.vue?vue&type=script&lang=js"
export * from "./ImportAbbreviationDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportAbbreviationDialog.vue?vue&type=style&index=0&id=f10ba7e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports